import React, { useState, useContext,createContext } from "react";
import { useSelector} from "react-redux";
const fields = [
  {
    name: "Country / Region *",
    type: "select",
    options: ["Afghanistan", "Albania", "Algeria", "Andorra"],
    required: true,
  },
  {
    name: "Name *",
    type: "text",
    required: true,
  },
  {
    name: "Company Name",
    type: "text",
    required: false,
  },
  {
    name: "Address Line  *",
    type: "text",
    required: true,
  },

  {
    name: "City *",
    type: "text",
    required: true,
  },
  {
    name: "State / Province / Region *",
    type: "select",
    required: false
  },
  {
    name: "Postal Code *",
    type: "text",
    required: true,
  },
];

const ModalContext = createContext();

const ModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <ModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

const AddressBook = () => {
  return (
    <div className="flex flex-col w-full">
      <ModalProvider>
        <Table />
        <Modal />
      </ModalProvider>
    </div>
  );
};

const Table = () => {
  // const dispatch = useDispatch();
  const { openModal } = useContext(ModalContext);
  const { shippingInfo } = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.auth);

  const handleRemove = () => {
    // dispatch(removeShippingInfo()); // For removing an existing address
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Name / Company
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Address
            </th>
            <th className="relative px-6 py-3">
              <span className="sr-only">Edit</span>
            </th>
            <th className="relative px-6 py-3">
              <span className="sr-only">Remove</span>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          <tr>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              {user?.name} {" / "} {user?.CompanyName}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {`${shippingInfo?.address}, ${shippingInfo?.city}, ${shippingInfo?.zipCode}, ${shippingInfo?.country}`}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
              <button
                onClick={() => openModal()}
                className="text-indigo-600 hover:text-indigo-900"
              >
                Edit
              </button>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
              <button
                onClick={() => handleRemove()}
                className="text-red-600 hover:text-red-900"
              >
                Remove
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const Modal = () => {
  const { isOpen, closeModal } = useContext(ModalContext);
  // // const dispatch = useDispatch();
  // const handleSubmit = (newAddress) => {
  //   //  dispatch(saveShippingInfo(newAddress)); // For adding or updating an address
  //  };

  //  const handleEdit = (updatedFields) => {
  //   //  dispatch(editShippingInfo(updatedFields)); // For editing an existing address
  //  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 transition-opacity"
          aria-hidden="true"
          onClick={closeModal}
        >
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <form
            // onSubmit={handleSubmit}
            className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            {fields.map((field, index) => (
              <div key={index} className="mb-4">
                <label
                  htmlFor={field.name}
                  className="block text-sm font-medium text-gray-700"
                >
                  {field.name}
                </label>
                {field.type === "select" ? (
                  <select
                    name={field.name}
                    id={field.name}
                    required={field.required}
                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                  >
                    <option value="">Select</option>
                    {field.options &&
                      field.options.map((option, idx) => (
                        <option key={idx} value={option}>
                          {option}
                        </option>
                      ))}
                  </select>
                ) : (
                  <input
                    type={field.type}
                    name={field.name}
                      id={field.name}
                      
                      required={field.required}
                      // onChange={(e) => handleEdit({ [field.name]: e.target.value })}
                      // value={shippingInfo}
                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                )}
              </div>
            ))}
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Add New Address
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddressBook;